var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.5C2 16.9853 4.01472 19 6.5 19H18.5C20.433 19 22 17.433 22 15.5C22 13.7367 20.6961 12.278 18.9999 12.0354C19.009 10.2322 18.3256 8.4261 16.9497 7.05025C14.2161 4.31658 9.78392 4.31658 7.05025 7.05025C6.15091 7.9496 5.54744 9.03278 5.23984 10.1788C3.36791 10.7238 2 12.4522 2 14.5Z",
    stroke: "#420000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L12 15M12 15L14 13M12 15L12 9",
    stroke: "#420000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.46f04e6565bb5a76314e3b50bff7355d.svg";
export { ForwardRef as ReactComponent };